import { Link } from 'react-router-dom';
import { VOICE_PATH } from '../reach/voiceWords';

/** Whether a copy edit is required, read-only: it's set in Voice & style (backlog da4682cb). */
export function CopyEditChip({ required }: { required: boolean }) {
  return (
    <span className="agc-chip" data-static="true">
      <span className="ink-dot agc-chip-dot" data-mode={required ? 'ask' : undefined} aria-hidden />
      {required ? 'Copy edit required' : 'No copy edit'} ·{' '}
      <Link to={`${VOICE_PATH}#copy-edit`}>Voice &amp; style →</Link>
    </span>
  );
}
